/** 缓存类型 */
const store_local = 'local'
const store_session = 'session'

export default {
    store_local,
    store_session
}


// WEBPACK FOOTER //
// ./src/utils/global_variable.js